import * as turf from '@turf/turf';
import { boundsboxArray, urlParams, map } from './_context.js';

/** Precomputed box for checkWithinBounds (avoids re-parsing boundsbox on every venue). */
export const boundsBoxCache = computeBoundsBoxCache(boundsboxArray);

function computeBoundsBoxCache(arr) {
    if (!arr || arr.length !== 4) {
        return { valid: false, maxLat: 0, minLat: 0, maxLng: 0, minLng: 0 };
    }
    const maxLat = Math.max(parseFloat(arr[0]), parseFloat(arr[1]));
    const minLat = Math.min(parseFloat(arr[0]), parseFloat(arr[1]));
    const maxLng = Math.max(parseFloat(arr[2]), parseFloat(arr[3]));
    const minLng = Math.min(parseFloat(arr[2]), parseFloat(arr[3]));
    return { valid: true, maxLat, minLat, maxLng, minLng };
}

export function checkWithinBounds(lng, lat) {
    if (boundsboxArray.length != 1 && boundsboxArray.length != 4) {
        console.log(
            'Mauvaise configuration du box bounds. Besoin de 4 valeurs, séparées par virgules (Nord,Sud,Est,Ouest). Le floating point doit être un point.',
        );
    }
    if (!boundsBoxCache.valid) {
        return true;
    }
    const { maxLat, minLat, maxLng, minLng } = boundsBoxCache;
    if (urlParams.get('boundsboxdebug') == 1) {
        const rectangle = new google.maps.Rectangle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map,
            bounds: {
                north: minLng,
                south: maxLng,
                east: maxLat,
                west: minLat,
            },
        });
        rectangle.setMap(map);
    }
    return maxLat > lat && minLat < lat && maxLng > lng && minLng < lng;
}

export function getGuaranteedInsidePoint(feature) {
    const geojson = feature;

    let insidePoint = null;
    if (shapeLabelPositionMethod == 'centerOfMass') {
        insidePoint = turf.centerOfMass(geojson);
    }
    if (shapeLabelPositionMethod == 'pointOnFeature') {
        insidePoint = turf.pointOnFeature(geojson);
    }
    if (shapeLabelPositionMethod == 'centroid') {
        insidePoint = turf.centroid(geojson);
    }

    const coords = insidePoint.geometry.coordinates;
    const lat = coords[1];
    const lng = coords[0];

    return new google.maps.LatLng(lat, lng);
}
